import { DESKTOP_WIDTH } from 'const';
import {
  FEScrollableTitledBottomSheet,
  FEScrollableTitledDialog,
} from 'components';
import { useMediaQuery } from 'ui-kit/hooks';
import style from './style.module.css';
import { Content } from './components';
import { useUnit } from 'effector-react';
import { $isPendingPromotions, $promotions } from 'domains/promotion';
import { useTranslation } from 'react-i18next';
import React from 'react';

const PromotionsPage = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) => {
  const { t } = useTranslation();
  const isDesktop = useMediaQuery(`(min-width: ${DESKTOP_WIDTH}px)`);
  const [clientMounted, setClientMounted] = React.useState(false);

  React.useEffect(() => setClientMounted(true), []);

  const [promotions, isPendingPromotions] = useUnit([
    $promotions,
    $isPendingPromotions,
  ]);

  const title = t('promotions.title');
  const content = ({ onClose }: { onClose: () => void }) => (
    <Content {...{ promotions, isPending: isPendingPromotions, onClose }} />
  );

  return (
    <>
      {open && !clientMounted && <h1 className='title'>{title}</h1>}
      {isDesktop ? (
        <FEScrollableTitledDialog
          title={title}
          titleAs='h1'
          containerClassName={style.container}
          open={open}
          onClose={onClose}
          render={content}
        />
      ) : (
        <FEScrollableTitledBottomSheet
          title={title}
          titleAs='h1'
          containerClassName={style.container}
          open={open}
          onClose={onClose}
          render={content}
        />
      )}
    </>
  );
};

export default PromotionsPage;
